import { useContext } from 'react';
import { IdentityContext } from './IdentityContext';

/**
 * EPN-240: whether the signed-in user's ACTIVE membership holds a permission, from `GET /api/me`. For hiding or disabling a control only: the server
 * re-checks every action, and its 403 stays the backstop. When the list is not known (an older server, the mock identity, still loading, no provider)
 * this answers true, so a control is never hidden on a guess; the server then decides.
 */
export function usePermissionCheck(): (code: string) => boolean {
  const granted = useContext(IdentityContext)?.me?.activePermissions;
  return (code: string) => granted === undefined || granted.includes(code);
}
